import { customDateFormatWithTime, textFormatter } from "components/Common/formatter";
import { USER_ROLES } from "utils/constants";

export const TABS = {
  EDIT_GEOFENCE: "EDIT_GEOFENCE",
  SECTORS: "SECTORS",
  DEPOT_HISTORY: "DEPOT_HISTORY",
  MINI_DEPOTS: "MINI_DEPOTS",
};

export const TABS_BUTTONS = [
  {
    title: "Edit Depot",
    key: TABS.EDIT_GEOFENCE,
  },
  {
    title: "Sectors",
    key: TABS.SECTORS,
    hideRoles: [USER_ROLES.MDSC],
  },
  {
    title: "Depot History",
    key: TABS.DEPOT_HISTORY,
    hideRoles: [USER_ROLES.MDSC],
  },
  {
    title: "Mini Depots",
    key: TABS.MINI_DEPOTS,
    roles: [
      USER_ROLES.SYSTEM_FULL_ADMINS,
      USER_ROLES.IT_OPERATIONS_LEADERSHIP,
      USER_ROLES.IT_OPERATIONS,
      USER_ROLES.DEPOT_CLERK,
      USER_ROLES.MWT,
      USER_ROLES.MDSC,
    ],
  },
];

export const depotHistoryColumns = () => [
  {
    title: "Updated At",
    dataIndex: "updatedAt",
    render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
  },
  {
    title: "Updated by",
    dataIndex: "updatedBy",
    render: textFormatter,
  },
  {
    title: "Changed Fields",
    dataIndex: "fields",
    render: textFormatter,
  },
];

export const ALLOWED_TEAMS = ["Maintenance", "Retention", "Repossession"];
